import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  SUBMIT_BUTTON: `${cleanedFilename(__filename)}-submit-button`,
  FORM: `${cleanedFilename(__filename)}-form`,
};
